// "Book this" on the home page's reg-price fold (pages/home/sections/hero/reg,
// LANDING_HERO, 25 Oct 2026) opens Book & pay with the wash, the plate and
// the size already in: /booking/book?reg=GX19XCV&service=mini_valet&size=large.
// The car the fold looked up rides in sessionStorage for this tab, so Book &
// pay shows "Grey Volvo XC90" at once instead of asking the lookup again; a
// link opened cold (no stash) gets the plate and size, and the Registration
// box looks the car up as if it had been typed (the server's cache answers,
// no second paid lookup).
//
// Pure apart from the storage, pinned by hero-prefill.test.mjs.
import { plate } from './vehicle.js'

export const HERO_CAR_KEY = 'gwmc_hero_car'
const SIZES = ['small', 'large']

// { reg: 'GX19XCV', size: 'large' | 'small' | null } from the parsed query,
// or null when it carries no plate.
export const heroPrefill = query => {
  const reg = plate(String(query?.reg || ''))
  return reg ? { reg, size: SIZES.includes(query.size) ? query.size : null } : null
}

const store = () => {
  try { return window.sessionStorage } catch (e) { return null }
}

export const keepHeroCar = (reg, car, s = store()) => {
  try { s.setItem(HERO_CAR_KEY, JSON.stringify({ reg, car })) } catch (e) { /* private mode: the lookup asks again */ }
}

// The kept car when it is this plate's, else null.
export const heroCar = (reg, s = store()) => {
  try {
    const kept = JSON.parse(s.getItem(HERO_CAR_KEY))
    return kept && kept.reg === reg && kept.car ? kept.car : null
  } catch (e) {
    return null
  }
}

// What Book & pay sets, in order: the car (before its plate, so the
// Registration box shows it without asking), the size and where it came
// from ('lookup' when the plate's car says it, else 'manual': picked on the
// fold, so a later answer never changes it), the plate.
export const prefillSteps = (p, car) => {
  const size = p.size || car?.suggested_size || null
  return {
    car: car ? { ...car, reg: p.reg } : null,
    size,
    sizeSource: size ? (car?.suggested_size === size ? 'lookup' : 'manual') : null
  }
}
